module.exports = __webpack_public_path__ + "static/nkbmLogo3-b14b840a9639aeae7cb634aa511dfa23.png";